<script>
/**
 * ****************************************************************************
 * @description     :   Input DatePicker Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import flatPickr from 'vue-flatpickr-component';
import _ from 'lodash-uuid';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
// import moment from 'moment';

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of input datepicker component
 */
var BsDatePicker = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        buttonClass: String,
        icon: String,
        placeholder: String,
        value: String,
        modelValue: String,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        isTimer: {
            type: Boolean,
            default: false
        },
        isMonthYear: {
            type: Boolean,
            default: false
        },
        isAllowMonthYear: {
            type: Boolean,
            default: false
        },
        autofocus: {
            type: Boolean,
            default: true
        },
        isAllowInput: { type: Boolean, default: true },
        onChangeEvent: Function,
        onFocus: Function,
        onBlur: Function,
        onClick: Function
    },
    components: {
        flatPickr
    },
    emits: ['update:modelValue'],
    data() {
        return {
            newId: '',
            isInputting: false,
            keyRender: 0,
            config_timer: {
                wrap: true,
                allowInput: this.isAllowInput,
                enableTime: true,
                noCalendar: true,
                dateFormat: 'H:i',
                time_24hr: true,
                clickOpens: false,
                locale: Japanese,
                onChange: this.updateInput
            }
        };
    },
    computed: {
        vewValue: {
            get() {
                return this.getValue(
                    this.modelValue ? this.modelValue : this.value
                );
            },
            set() {}
        },
        config_datetime() {
            return {
                wrap: true,
                altFormat: this.isMonthYear ? 'Y/m' : 'Y/m/d',
                altInput: true,
                dateFormat: this.isMonthYear ? 'Y/m' : 'Y/m/d',
                allowInput: this.isAllowInput,
                clickOpens: false,
                monthSelectorType: 'static',
                locale: Japanese,
                onChange: this.updateInput
            };
        },
        maxlength() {
            return this.isTimer ? 5 : this.isMonthYear ? 7 : 10;
        }
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
        } else {
            this.newId = _.uuid();
        }
    },
    methods: {
        /**
         * convert date for input datepiker
         * -----------------------------------------
         * @author : QuanHVM - 2023/02/15 - create
         * @params : value
         * @access : private
         */
        convertTimeString(value) {
            if (value == undefined || value == '' || value == null) {
                return '';
            }
            var reg1 = /^[0-2]{1}[0-9]{1}[0-5]{1}[0-9]{1}$/;
            var reg2 = /^[0-2]{1}[0-9]{1}[:][0-5]{1}[0-9]{1}$/;
            if (value.match(reg1)) {
                value = value.substring(0, 2) + ':' + value.substring(2, 4);
            }
            if (!value.match(reg1) && !value.match(reg2)) {
                value = '';
            }
            return value;
        },
        /**
         * convert date for input datepiker
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params : value
         * @access : private
         */
        convertDateString(value) {
            if (value == undefined || value == '' || value == null) {
                return '';
            }
            var reg1 = /^[0-9]{8}$/;
            var reg2 = /^[0-9]{4}[/.][0-9]{2}[/.][0-9]{2}$/;
            if (value.match(reg1)) {
                value =
                    value.substring(0, 4) +
                    '/' +
                    value.substring(4, 6) +
                    '/' +
                    value.substring(6);
            }
            if (!value.match(reg1) && !value.match(reg2)) {
                value = '';
            }
            if (!this.isDate(value)) {
                value = '';
            }
            return value;
        },
        /**
         * convert year/month for input datepicker
         * -----------------------------------------
         * @author : HieuNM - 2023/03/15 - create
         * @params : value
         * @access : private
         */
        convertYearMonthString(value) {
            if (value == undefined || value == '' || value == null) {
                return '';
            }
            var reg1 = /^[0-9]{6}$/;
            var reg2 = /^[0-9]{4}[/.][0-9]{2}$/;
            if (value.match(reg1)) {
                value = value.substring(0, 4) + '/' + value.substring(4, 6);
            }
            if (!value.match(reg1) && !value.match(reg2)) {
                value = '';
            }
            return value;
        },
        /**
         * Check date type for input datepiker
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params : value
         * @access : private
         */
        isDate(string) {
            if (string == '') {
                return true;
            }
            if (string.length == 8) {
                string =
                    string.substring(0, 4) +
                    '/' +
                    string.substring(4, 6) +
                    '/' +
                    string.substring(6);
            }
            var reg =
                /^((19|[2-9][0-9])[0-9]{2})[/.](0[13578]|1[02])[/.]31|((19|[2-9][0-9])[0-9]{2}[/.](01|0[3-9]|1[0-2])[/.](29|30))|((19|[2-9][0-9])[0-9]{2}[/.](0[1-9]|1[0-2])[/.](0[1-9]|1[0-9]|2[0-8]))|((((19|[2-9][0-9])(04|08|[2468][048]|[13579][26]))|2000)[/.](02)[/.]29)$/;
            if (string.match(reg)) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * event keydown on input datepiker
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        inputKeydown(e) {
            if (!this.isTimer) {
                if (
                    !(
                        (e.keyCode > 47 && e.keyCode < 58) ||
                        (e.keyCode > 95 && e.keyCode < 106) ||
                        e.keyCode == 116 ||
                        e.keyCode == 13 ||
                        e.keyCode == 46 ||
                        e.keyCode == 37 ||
                        e.keyCode == 39 ||
                        e.keyCode == 35 ||
                        e.keyCode == 36 ||
                        e.keyCode == 8 ||
                        e.keyCode == 9 ||
                        e.ctrlKey ||
                        e.keyCode == 229 ||
                        e.keyCode == 191
                    )
                ) {
                    event.preventDefault();
                    return false;
                }
            } else {
                if (
                    !(
                        (e.keyCode > 47 && e.keyCode < 58) ||
                        (e.keyCode > 95 && e.keyCode < 106) ||
                        e.keyCode == 116 ||
                        e.keyCode == 13 ||
                        e.keyCode == 46 ||
                        e.keyCode == 37 ||
                        e.keyCode == 39 ||
                        e.keyCode == 35 ||
                        e.keyCode == 36 ||
                        e.keyCode == 8 ||
                        e.keyCode == 9 ||
                        e.ctrlKey ||
                        e.keyCode == 229 ||
                        e.keyCode == 186
                    )
                ) {
                    event.preventDefault();
                    return false;
                }
            }
            return true;
        },
        onChange(e) {
            let val = this.getValue(e.target.value);
            if (val === '') {
                this.keyRender++;
            }
            if ((this.vewValue ?? '') != (val ?? '')) {
                this.isInputting = true;
                this.$emit('update:modelValue', val);
                if (this.onChangeEvent) {
                    this.onChangeEvent(val, null);
                }
            }
        },
        getValue(input) {
            let val = '';
            if (this.isTimer) {
                val = this.convertTimeString(input);
            } else if (
                this.isMonthYear ||
                (this.isAllowMonthYear && input?.length < 8)
            ) {
                val = this.convertYearMonthString(input);
            } else {
                val = this.convertDateString(input);
            }
            return val;
        },
        /**
         * update input datepiker
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        // eslint-disable-next-line no-unused-vars
        updateInput(selectedDates, dateStr) {
            if (this.autofocus) {
                this.$refs['input_' + this.newId].focus();
            }
            if ((this.vewValue ?? '') != (dateStr ?? '') && !this.isInputting) {
                this.$emit('update:modelValue', dateStr);
                if (this.onChangeEvent) {
                    this.onChangeEvent(dateStr, selectedDates);
                }
            }
            this.isInputting = false;
        }
    }
};
export default BsDatePicker;
</script>
